import { Carousel as NukaCarousel, useCarousel } from 'nuka-carousel';
import { useIntl } from 'react-intl';

import NextNavIcon from 'icons/next-nav-icon.svg';
import PrevNavIcon from 'icons/prev-nav-icon.svg';

import ContentSlide from '../ContentSlide';
import messages from './messages';
import { BottomNav, CarouselWrapper, MobileHeading, NavArrow, NavItem, Wrapper } from './styles';
import { CarouselProps } from './types';

const Dots = ({ slides }: Pick<CarouselProps, 'slides'>) => {
	const { totalPages, currentPage } = useCarousel();

	return (
		<BottomNav>
			{Array.from(Array(totalPages).keys()).map((_, index) => (
				<NavItem isActive={index === currentPage} key={slides[index].title} />
			))}
		</BottomNav>
	);
};

const Arrows = () => {
	const { goBack, goForward } = useCarousel();

	return (
		<>
			<NavArrow onClick={goBack}>
				<PrevNavIcon />
			</NavArrow>
			<NavArrow onClick={goForward} isRight>
				<NextNavIcon />
			</NavArrow>
		</>
	);
};

const Carousel = ({ slides }: CarouselProps) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<CarouselWrapper>
				<MobileHeading>{formatMessage(messages.title)}</MobileHeading>
				<NukaCarousel wrapMode="wrap" showDots dots={<Dots slides={slides} />} showArrows arrows={<Arrows />}>
					{slides.map(slide => (
						<ContentSlide
							key={slide.title}
							heading={formatMessage(messages.title)}
							description=""
							tileUrl={slide.tileUrl}
							tileImage={slide.tileImage}
							tileTitle=""
							tileDescription={slide.description}
						/>
					))}
				</NukaCarousel>
			</CarouselWrapper>
		</Wrapper>
	);
};

export default Carousel;
